import { render, staticRenderFns } from "./EstimatesTab.vue?vue&type=template&id=948bc1b0&"
import script from "./EstimatesTab.vue?vue&type=script&lang=js&"
export * from "./EstimatesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('948bc1b0')) {
      api.createRecord('948bc1b0', component.options)
    } else {
      api.reload('948bc1b0', component.options)
    }
    module.hot.accept("./EstimatesTab.vue?vue&type=template&id=948bc1b0&", function () {
      api.rerender('948bc1b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/customization-tabs/EstimatesTab.vue"
export default component.exports